import { AlertWithTitle } from '~/components/AlertWithTitle'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import * as S from './styles'

/** Flip to `false` (or remove the mount) when the incident is resolved. */
export const SHOW_SYSTEM_INSTABILITY_BANNER = false

type SystemInstabilityBannerProps = {
  enabled?: boolean
}

export function SystemInstabilityBanner({
  enabled = SHOW_SYSTEM_INSTABILITY_BANNER
}: SystemInstabilityBannerProps = {}) {
  const { t } = useAPPTranslation()

  if (!enabled) return null

  return (
    <S.Container data-testid="system-instability-banner">
      <AlertWithTitle
        variant="warning"
        title={t('c:components.SystemInstabilityBanner.title')}
        description={t('c:components.SystemInstabilityBanner.message')}
      />
    </S.Container>
  )
}

export default SystemInstabilityBanner
